// extracted by css-extract-rspack-plugin
export default {"root":"wujvh0","avatar":"q16Arm"};